//firebaseapi.jsx
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { REGIONS, currentRegion } from '@common/src/config/regions'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)

const auth = getAuth(app)

/** Firestore database of a region: the default database for home, the region's named database otherwise. */
const getDbForRegion = (key) => {
  const region = REGIONS[key] || REGIONS.home
  return region.firestoreDb ? getFirestore(app, region.firestoreDb) : getFirestore(app)
}

/** Global data (users, roles, master permissions) — always the home database. */
const homeDb = getFirestore(app)
/** Regional data (companies, stores and everything under them, orders, …) for the region this page load runs in. */
const db = getDbForRegion(currentRegion.key)

/** Home Cloud Functions — also used for functions that only exist in home (see cloud.js). */
const homeFunctions = getFunctions(app, REGIONS.home.functionsRegion)
/** Cloud Functions of the current region. */
const functions = currentRegion.isHome ? homeFunctions : getFunctions(app, currentRegion.functionsRegion)

export { db, homeDb, getDbForRegion, auth, functions, homeFunctions }
